import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuescroll from 'vuescroll/dist/vuescroll-native'
import AsyncComputed from 'vue-async-computed'
import DeviceDetect from './mixins/DeviceDetect'
import Layout from './mixins/Layout'
import Language from './mixins/Language'
import VueSocialSharing from 'vue-social-sharing'
import VTooltip from 'v-tooltip'
import VueGtm from 'vue-gtm'

import { v4 as uuid } from 'uuid'
window.__sessionId = uuid()

Vue.mixin(DeviceDetect)
Vue.mixin(Layout)
Vue.mixin(Language)
Vue.config.productionTip = false
Vue.use(AsyncComputed)
Vue.use(vuescroll)
Vue.use(VueSocialSharing)
Vue.use(VTooltip)

Vue.use(VueGtm, {
  id: 'GTM-P5JSM4P', // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryPararms: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}]
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
})

router.afterEach((to, from) => {
  //let currentPath = window.location.origin + window.location.pathname + to.fullPath

  // track GA events only when specific parameters change or if path changes
  let shouldTrack = to.path != from.path
  let paramsToCheck = ['mainCubeId', 'countries', 'chart', 'pairIndId'];
  for (const param of paramsToCheck) {
    if (to.query[param] !== from.query[param]) {
      shouldTrack = true;
      break;
    }
  }
  if(shouldTrack) {
    let currentPath = to.path
    if (to.query) {
      let filteredQuery = Object.fromEntries(Object.entries(to.query).filter(([key]) => paramsToCheck.includes(key)))
      currentPath += '?' + new URLSearchParams(filteredQuery).toString()
    }
    window.dataLayer?.push({
      event: 'page_view',
      page_current_path: currentPath,
      is_global: 'yes',
      is_directorates: 'no',
      is_satellite: 'yes'
    });
  }
  //this.$gtm.trackView(to.name, );
})

new Vue({
  router,
  store,
  computed: {
    version() {
      return this.$route.params.version
        ? this.$route.params.version !== 'undefined' &&
            this.$route.params.version !== 'null' &&
            this.$route.params.version
        : null
    },
  },
  render: function(createElement) {
    if (!this.version) throw new Error('Unknown app version')
    window.__versionId = this.version

    return createElement(App)
  },
}).$mount('#app')
